import { defineNuxtPlugin, useRouter } from 'nuxt/app'
import type { RouteLocation } from 'vue-router'
import { isNull } from 'lodash-es'
import { COUNTRY_CODE, getCountryFromUrl } from '~/core/i18n'

const initYandexMetrika = () => {
  (function(m, e, t, r, i, k, a) {
    // @ts-ignore
    m[i] = m[i] || function() {
      // @ts-ignore
      // eslint-disable-next-line
      (m[i].a = m[i].a || []).push(arguments)
    }
    // @ts-ignore
    m[i].l = 1 * new Date()
    // @ts-ignore
    // eslint-disable-next-line
    k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

  const { hostname } = useRequestURL()
  const country = getCountryFromUrl({ hostname })
  const { ymCounterIdRu, ymCounterIdKz, ymCounterIdBy, ymCounterIdKg } = useRuntimeConfig().public
  let counterId: string | null = null

  switch (country) {
    case COUNTRY_CODE.RU:
      counterId = ymCounterIdRu
      break
    case COUNTRY_CODE.KZ:
      counterId = ymCounterIdKz
      break
    case COUNTRY_CODE.BY:
      counterId = ymCounterIdBy
      break
    case COUNTRY_CODE.KG:
      counterId = ymCounterIdKg
      break
  }

  if (!counterId) {
    return null
  }

  const numericCounter = Number(counterId)

  window.ym(numericCounter, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  })

  return numericCounter
}

export default defineNuxtPlugin(() => {
  const $router = useRouter()

  const numericCounter = initYandexMetrika()

  if (isNull(numericCounter)) {
    return
  }

  $router?.afterEach((to: RouteLocation, from: RouteLocation) => {
    const baseUrl = location.origin

    window.ym(numericCounter, 'hit', baseUrl + to.fullPath, {
      referer: baseUrl + from.fullPath,
    })
  })
})
